import { mask as masker } from "remask";

const mask = (event) => {
  const textField = document.querySelector(".rw-new-message");

  textField.removeEventListener("keydown", cpfListener);
  textField.removeEventListener("keydown", phoneListener);
  textField.setAttribute("maxlength", "");
  textField.setAttribute("disabled", "");
  textField.setAttribute("hidden", "");

  if (event?.text === "Qual é o seu **nome completo**?") {
    textField.removeAttribute("disabled");
    textField.removeAttribute("hidden");
  }

  if (event?.text === "Digite seu **CPF**?") {
    cpfMask(textField);
    textField.removeAttribute("disabled");
    textField.removeAttribute("hidden");
  }

  if (event?.text === "Qual o seu **e-mail**?") {
    textField.removeAttribute("disabled");
    textField.removeAttribute("hidden");
  }

  if (
    event?.text ===
    "Qual é o seu **número de celular**? Não se esqueça do DDD"
  ) {
    phoneMask(textField);
    textField.removeAttribute("disabled");
    textField.removeAttribute("hidden");
  }

  if (event?.text === "Agora, nos conte com mais detalhes o que está acontecendo.") {
    textField.removeAttribute("disabled");
    textField.removeAttribute("hidden");
  }
};

const cpfMask = (textField) => {
  textField.setAttribute("maxlength", "14");
  // textField.addEventListener("keydown", cpfListener);
};

const cpfListener = (e) => {
  setTimeout(() => (e.target.value = cpfRegex(e.target.value)), 1);
};

const cpfRegex = (text) => {
  text = masker(text, ["999.999.999-99"]);
  return text;
};

const phoneMask = (textField) => {
  textField.setAttribute("maxlength", "15");
  // textField.addEventListener("keydown", phoneListener);
};

const phoneListener = (e) => {
  setTimeout(() => (e.target.value = phoneRegex(e.target.value)), 1);
};

const phoneRegex = (text) => {
  text = masker(text, "(99) 99999-9999");
  return text;
};

export default mask;
